<template>
  <div class="package-cpu-architecture">
    <HollowDotsSpinner
      v-if="isSaving || isFetching"
      :animation-duration="1000"
      :dot-size="12"
      :dots-num="3"
      :color="'#95a5a6'"
    />

    <div v-else class="flex-container">
      <span
        :title="selectedCpuValue"
        class="text-latin package-cpu-architecture__value"
      >
        {{ selectedCpuValue }}
      </span>

      <TableCellEdit
        v-if="canEdit"
        type="select"
        key-prop="value"
        label-prop="value"
        value-prop="name"
        :title="$t('APP.RELEASES.CPU_ARCHITECTURE')"
        :items="cpuArchitectures"
        :initial-value="packageItem.cpuArchitectures"
        @save="updateCpuArchitecture"
      />
    </div>
  </div>
</template>

<script>
import packageName from '@/mixins/packageName';
import { Release } from '@/api/api';
import TableCellEdit from '@@/common/TableCellEdit';
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';
import { mapActions, mapGetters } from 'vuex';
import {
  CPU_ARCHITECTURES,
  IS_FETCHING_CPU_ARCHITECTURES,
} from '@/store/types';

export default {
  name: 'ReleasePackageArchitecture',
  components: {
    TableCellEdit,
    HollowDotsSpinner,
  },
  mixins: [packageName],
  props: {
    packageItem: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cpuArchitecture: this.packageItem.cpuArchitectures,
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters({
      cpuArchitectures: CPU_ARCHITECTURES,
      isFetching: IS_FETCHING_CPU_ARCHITECTURES,
    }),
    selectedCpuValue() {
      const selectedCpu = this.cpuArchitectures.find(
        cpu => cpu.name === this.cpuArchitecture,
      );
      return selectedCpu?.value;
    },
  },
  created() {
    this.getCpuArchitectures();
  },
  methods: {
    ...mapActions({ getCpuArchitectures: CPU_ARCHITECTURES }),
    updateCpuArchitecture(architecture) {
      const requestParams = {
        packageName: this.packageName,
        token: this.packageItem.token,
        architecture,
      };

      this.isSaving = true;
      return Release.updateCpuArchitectures(requestParams)
        .then(({ message }) => {
          if (message) {
            this.$message.success(message);
          }

          this.cpuArchitecture = architecture;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<style lang="scss">
.package-cpu-architecture {
  &__value {
    padding: $--button-mini-padding-vertical/2 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
